import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/dudak-dolgusu-sonrasi-alkol-tuketimi-bilimsel-etkiler-klinik-bulgular-ve-estetik-sonuclar/page.tsx");
